import React, { useEffect, useRef } from 'react';

interface FormErrorComponentProps {
  error?: string;
}

export const FormErrorComponent: React.FC<FormErrorComponentProps> = React.memo(
  ({ error }: FormErrorComponentProps) => {
    const titleRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
      if (error) {
        titleRef.current?.focus();
      }
    }, [error]);

    return !error ? null : (
      <div className="fr-alert fr-alert--error fr-alert--sm  fr-mb-6w" role="alert">
        <h3
          ref={titleRef}
          aria-describedby="form-error-details"
          className="fr-alert__title fc-alert-title-focusable"
          tabIndex={-1}>
          Le message n&rsquo;a pas pu être envoyé
        </h3>
        <p id="form-error-details">{error}</p>
      </div>
    );
  },
);

FormErrorComponent.displayName = 'FormErrorComponent';
